// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex-employment-page {
  min-height: 100%;
  padding: 24px;
  background: linear-gradient(180deg, #f6f9fc 0%, #eef3f8 100%);
}

.flex-employment-public-page {
  position: relative;
  overflow: hidden;
  background: radial-gradient(circle at top left, rgba(244, 193, 101, 0.24) 0%, rgba(244, 193, 101, 0) 28%), radial-gradient(circle at top right, rgba(38, 99, 163, 0.22) 0%, rgba(38, 99, 163, 0) 30%), linear-gradient(180deg, #fff8ef 0%, #f3f7fb 34%, #e9f0f7 100%);
}

.flex-employment-shell {
  max-width: 1160px;
  margin: 0 auto;
}

.flex-employment-hero {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  align-items: flex-start;
  margin-bottom: 24px;
  padding: 24px 28px;
  border-radius: 20px;
  background: linear-gradient(135deg, #0f1f36 0%, #17345c 55%, #2663a3 100%);
  color: #f7fbff;
  box-shadow: 0 16px 40px rgba(15, 31, 54, 0.22);
}

.flex-employment-hero h1,
.flex-employment-hero h2 {
  margin: 0 0 10px;
  font-size: 2rem;
}

.flex-employment-hero p {
  margin: 0;
  max-width: 700px;
  line-height: 1.6;
  color: rgba(247, 251, 255, 0.9);
}

.flex-employment-public-hero {
  position: relative;
  overflow: hidden;
  align-items: stretch;
  padding: 34px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: linear-gradient(135deg, rgba(14, 23, 41, 0.96) 0%, rgba(19, 56, 93, 0.96) 52%, rgba(180, 92, 38, 0.9) 100%), linear-gradient(135deg, #0f1f36 0%, #17345c 55%, #2663a3 100%);
}

.flex-employment-public-hero::after {
  content: "";
  position: absolute;
  right: -80px;
  top: -100px;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 209, 149, 0.28) 0%, rgba(255, 209, 149, 0) 72%);
}

.flex-employment-public-hero-copy {
  position: relative;
  z-index: 1;
  max-width: 700px;
}

.flex-employment-public-hero-copy h1 {
  max-width: 650px;
  font-size: clamp(2.5rem, 4vw, 4.3rem);
  line-height: 0.96;
  letter-spacing: -0.04em;
}

.flex-employment-kicker {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  border-radius: 999px;
  padding: 7px 12px;
  background: rgba(255, 255, 255, 0.12);
  color: #fff0d8;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.flex-employment-public-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 24px;
}

.flex-employment-public-pills span {
  border-radius: 999px;
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.1);
  color: #fdf4e7;
  font-weight: 600;
}

.flex-employment-hero-panel {
  position: relative;
  z-index: 1;
  display: grid;
  gap: 14px;
  min-width: 260px;
  align-self: center;
  padding: 18px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
}

.flex-employment-hero-stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.flex-employment-hero-stat strong {
  font-size: 2rem;
  line-height: 1;
}

.flex-employment-hero-stat span,
.flex-employment-hero-locations span {
  color: rgba(247, 251, 255, 0.88);
}

.flex-employment-hero-locations {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.flex-employment-hero-locations span {
  border-radius: 999px;
  padding: 8px 10px;
  background: rgba(255, 255, 255, 0.1);
  font-size: 0.88rem;
}

.flex-employment-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.flex-employment-button,
.flex-employment-button-secondary,
.flex-employment-button-danger {
  border: none;
  border-radius: 10px;
  padding: 11px 16px;
  font-weight: 700;
  cursor: pointer;
}

.flex-employment-button {
  background: linear-gradient(135deg, #1d63d8 0%, #0f8ec4 100%);
  color: #fff;
  box-shadow: 0 12px 24px rgba(20, 78, 145, 0.18);
}

.flex-employment-button-secondary {
  background: #e8f0fb;
  color: #123766;
}

.flex-employment-button-danger {
  background: #fee2e2;
  color: #991b1b;
}

.flex-employment-button:disabled,
.flex-employment-button-secondary:disabled,
.flex-employment-button-danger:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.flex-employment-status {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
}

.flex-employment-status.open {
  background: #dcfce7;
  color: #166534;
}

.flex-employment-status.closed {
  background: #e5e7eb;
  color: #4b5563;
}

.flex-employment-banner,
.flex-employment-error,
.flex-employment-success {
  margin-bottom: 20px;
  padding: 14px 16px;
  border-radius: 12px;
  font-weight: 500;
}

.flex-employment-banner {
  background: #e0f2fe;
  color: #0c4a6e;
}

.flex-employment-error {
  background: #fee2e2;
  color: #991b1b;
}

.flex-employment-success {
  background: #dcfce7;
  color: #166534;
}

.flex-employment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
  gap: 22px;
}

.flex-employment-card {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid rgba(187, 205, 226, 0.7);
  box-shadow: 0 18px 35px rgba(28, 48, 81, 0.08);
}

.flex-employment-public-card {
  position: relative;
  overflow: hidden;
  padding: 22px;
  border-radius: 24px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(250, 252, 255, 0.98) 100%);
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
}

.flex-employment-public-card:hover {
  transform: translateY(-4px);
  border-color: rgba(34, 107, 184, 0.34);
  box-shadow: 0 24px 48px rgba(28, 48, 81, 0.14);
}

.flex-employment-public-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(253, 235, 208, 0.45) 0%, rgba(253, 235, 208, 0) 34%);
  pointer-events: none;
}

.flex-employment-public-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.flex-employment-public-rate {
  color: #0f3f73;
  font-size: 0.96rem;
  font-weight: 800;
}

.flex-employment-card h3 {
  margin: 0;
  color: #10243d;
  font-size: 1.45rem;
  letter-spacing: -0.03em;
}

.flex-employment-card p {
  margin: 0;
  color: #42556d;
  line-height: 1.5;
}

.flex-employment-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 16px;
}

.flex-employment-meta > div {
  padding: 12px 14px;
  border-radius: 14px;
  background: rgba(238, 244, 251, 0.85);
}

.flex-employment-meta strong {
  display: block;
  margin-bottom: 4px;
  color: #10243d;
}

.flex-employment-skills {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.flex-employment-skill {
  border-radius: 999px;
  padding: 7px 11px;
  background: #edf5ff;
  color: #18437a;
  font-size: 0.85rem;
  font-weight: 600;
}

.flex-employment-public-muted {
  color: #6c7b8f;
}

.flex-employment-card-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: auto;
}

.flex-employment-search {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 16px;
  align-items: end;
  margin-bottom: 20px;
  padding: 22px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(187, 205, 226, 0.7);
  box-shadow: 0 18px 34px rgba(20, 54, 92, 0.08);
  backdrop-filter: blur(12px);
}

.flex-employment-search-field {
  margin-bottom: 0;
}

.flex-employment-search-actions {
  display: flex;
  gap: 10px;
}

.flex-employment-public-toolbar {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: end;
  margin-bottom: 18px;
}

.flex-employment-public-toolbar h2 {
  margin: 8px 0 0;
  color: #10243d;
  font-size: clamp(1.5rem, 2vw, 2.1rem);
  letter-spacing: -0.03em;
}

.flex-employment-public-toolbar p {
  max-width: 420px;
  margin: 0;
  color: #55667d;
  line-height: 1.6;
}

.flex-employment-form {
  display: grid;
  gap: 16px;
  padding: 24px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #dbe5f1;
  box-shadow: 0 10px 24px rgba(20, 54, 92, 0.08);
}

.flex-employment-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.flex-employment-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.flex-employment-field.full-width {
  grid-column: 1/-1;
}

.flex-employment-field label {
  font-weight: 700;
  color: #10243d;
}

.flex-employment-field input,
.flex-employment-field select,
.flex-employment-field textarea {
  width: 100%;
  border: 1px solid #c8d6e5;
  border-radius: 10px;
  padding: 10px 12px;
  font: inherit;
  color: #10243d;
  background: #fff;
  box-sizing: border-box;
}

.flex-employment-field textarea {
  min-height: 120px;
  resize: vertical;
}

.flex-employment-field input:focus,
.flex-employment-field select:focus,
.flex-employment-field textarea:focus {
  outline: none;
  border-color: #1a73e8;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.16);
}

.flex-employment-section-title {
  margin: 0 0 8px;
  color: #10243d;
}

.flex-employment-empty {
  padding: 32px;
  border-radius: 18px;
  background: #fff;
  border: 1px dashed #c8d6e5;
  text-align: center;
  color: #42556d;
}

.flex-employment-candidate-list {
  display: grid;
  gap: 14px;
}

.flex-employment-candidate {
  border: 1px solid #dbe5f1;
  border-radius: 14px;
  padding: 16px;
}

.flex-employment-candidate h4 {
  margin: 0 0 8px;
  color: #10243d;
}

.flex-employment-loading {
  padding: 24px 0;
  color: #42556d;
}

@media (max-width: 800px) {
  .flex-employment-hero,
  .flex-employment-form-grid,
  .flex-employment-meta {
    grid-template-columns: 1fr;
    display: grid;
  }
  .flex-employment-page {
    padding: 16px;
  }
  .flex-employment-public-toolbar,
  .flex-employment-public-card-top,
  .flex-employment-public-hero {
    display: grid;
    grid-template-columns: 1fr;
  }
  .flex-employment-search {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/flexible-employment/FlexibleEmployment.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,6DAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,qQACE;AAAJ;;AAKA;EACE,iBAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0EAAA;EACA,cAAA;EACA,8CAAA;AAFF;;AAKA;;EAEE,gBAAA;EACA,eAAA;AAFF;;AAKA;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,2CAAA;EACA,uLACE;AAHJ;;AAOA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,6FAAA;AAJF;;AAOA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,qCAAA;EACA,iBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,qCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAJF;;AAOA;EACE,oBAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,gBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,oBAAA;EACA,kDAAA;AAJF;;AAOA;EACE,eAAA;EACA,cAAA;AAJF;;AAOA;;EAEE,gCAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAJF;;AAOA;EACE,oBAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;AAJF;;AAOA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAJF;;AAOA;;;EAGE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAJF;;AAOA;EACE,6DAAA;EACA,WAAA;EACA,+CAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAOA;;;EAGE,mBAAA;EACA,YAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAOA;;;EAGE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,8CAAA;AAJF;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iGACE;EACF,gFAAA;AALF;;AAQA;EACE,2BAAA;EACA,sCAAA;EACA,8CAAA;AALF;;AAQA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,6FAAA;EACA,oBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AALF;;AAQA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;AALF;;AAQA;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;AALF;;AAQA;EACE,kBAAA;EACA,mBAAA;EACA,qCAAA;AALF;;AAQA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AALF;;AAQA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AALF;;AAQA;EACE,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,0CAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,0CAAA;EACA,8CAAA;EACA,2BAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,SAAA;AALF;;AAQA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AALF;;AAQA;EACE,eAAA;EACA,cAAA;EACA,qCAAA;EACA,uBAAA;AALF;;AAQA;EACE,gBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,8CAAA;AALF;;AAQA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,gBAAA;EACA,cAAA;AALF;;AAQA;;;EAGE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AALF;;AAQA;EACE,iBAAA;EACA,gBAAA;AALF;;AAQA;;;EAGE,aAAA;EACA,qBAAA;EACA,8CAAA;AALF;;AAQA;EACE,eAAA;EACA,cAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;AALF;;AAQA;EACE,aAAA;EACA,SAAA;AALF;;AAQA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;AALF;;AAQA;EACE,eAAA;EACA,cAAA;AALF;;AAQA;EACE,eAAA;EACA,cAAA;AALF;;AAQA;EACE;;;IAGE,0BAAA;IACA,aAAA;EALF;EAQA;IACE,aAAA;EANF;EASA;;;IAGE,aAAA;IACA,0BAAA;EAPF;EAUA;IACE,0BAAA;EARF;AACF","sourcesContent":[".flex-employment-page {\n  min-height: 100%;\n  padding: 24px;\n  background: linear-gradient(180deg, #f6f9fc 0%, #eef3f8 100%);\n}\n\n.flex-employment-public-page {\n  position: relative;\n  overflow: hidden;\n  background:\n    radial-gradient(circle at top left, rgba(244, 193, 101, 0.24) 0%, rgba(244, 193, 101, 0) 28%),\n    radial-gradient(circle at top right, rgba(38, 99, 163, 0.22) 0%, rgba(38, 99, 163, 0) 30%),\n    linear-gradient(180deg, #fff8ef 0%, #f3f7fb 34%, #e9f0f7 100%);\n}\n\n.flex-employment-shell {\n  max-width: 1160px;\n  margin: 0 auto;\n}\n\n.flex-employment-hero {\n  display: flex;\n  justify-content: space-between;\n  gap: 24px;\n  align-items: flex-start;\n  margin-bottom: 24px;\n  padding: 24px 28px;\n  border-radius: 20px;\n  background: linear-gradient(135deg, #0f1f36 0%, #17345c 55%, #2663a3 100%);\n  color: #f7fbff;\n  box-shadow: 0 16px 40px rgba(15, 31, 54, 0.22);\n}\n\n.flex-employment-hero h1,\n.flex-employment-hero h2 {\n  margin: 0 0 10px;\n  font-size: 2rem;\n}\n\n.flex-employment-hero p {\n  margin: 0;\n  max-width: 700px;\n  line-height: 1.6;\n  color: rgba(247, 251, 255, 0.9);\n}\n\n.flex-employment-public-hero {\n  position: relative;\n  overflow: hidden;\n  align-items: stretch;\n  padding: 34px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background:\n    linear-gradient(135deg, rgba(14, 23, 41, 0.96) 0%, rgba(19, 56, 93, 0.96) 52%, rgba(180, 92, 38, 0.9) 100%),\n    linear-gradient(135deg, #0f1f36 0%, #17345c 55%, #2663a3 100%);\n}\n\n.flex-employment-public-hero::after {\n  content: '';\n  position: absolute;\n  right: -80px;\n  top: -100px;\n  width: 280px;\n  height: 280px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(255, 209, 149, 0.28) 0%, rgba(255, 209, 149, 0) 72%);\n}\n\n.flex-employment-public-hero-copy {\n  position: relative;\n  z-index: 1;\n  max-width: 700px;\n}\n\n.flex-employment-public-hero-copy h1 {\n  max-width: 650px;\n  font-size: clamp(2.5rem, 4vw, 4.3rem);\n  line-height: 0.96;\n  letter-spacing: -0.04em;\n}\n\n.flex-employment-kicker {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n  border-radius: 999px;\n  padding: 7px 12px;\n  background: rgba(255, 255, 255, 0.12);\n  color: #fff0d8;\n  font-size: 0.76rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n}\n\n.flex-employment-public-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 24px;\n}\n\n.flex-employment-public-pills span {\n  border-radius: 999px;\n  padding: 10px 14px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #fdf4e7;\n  font-weight: 600;\n}\n\n.flex-employment-hero-panel {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  gap: 14px;\n  min-width: 260px;\n  align-self: center;\n  padding: 18px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(12px);\n}\n\n.flex-employment-hero-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.flex-employment-hero-stat strong {\n  font-size: 2rem;\n  line-height: 1;\n}\n\n.flex-employment-hero-stat span,\n.flex-employment-hero-locations span {\n  color: rgba(247, 251, 255, 0.88);\n}\n\n.flex-employment-hero-locations {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.flex-employment-hero-locations span {\n  border-radius: 999px;\n  padding: 8px 10px;\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 0.88rem;\n}\n\n.flex-employment-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.flex-employment-button,\n.flex-employment-button-secondary,\n.flex-employment-button-danger {\n  border: none;\n  border-radius: 10px;\n  padding: 11px 16px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.flex-employment-button {\n  background: linear-gradient(135deg, #1d63d8 0%, #0f8ec4 100%);\n  color: #fff;\n  box-shadow: 0 12px 24px rgba(20, 78, 145, 0.18);\n}\n\n.flex-employment-button-secondary {\n  background: #e8f0fb;\n  color: #123766;\n}\n\n.flex-employment-button-danger {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.flex-employment-button:disabled,\n.flex-employment-button-secondary:disabled,\n.flex-employment-button-danger:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.flex-employment-status {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  padding: 6px 12px;\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.flex-employment-status.open {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.flex-employment-status.closed {\n  background: #e5e7eb;\n  color: #4b5563;\n}\n\n.flex-employment-banner,\n.flex-employment-error,\n.flex-employment-success {\n  margin-bottom: 20px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  font-weight: 500;\n}\n\n.flex-employment-banner {\n  background: #e0f2fe;\n  color: #0c4a6e;\n}\n\n.flex-employment-error {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.flex-employment-success {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.flex-employment-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));\n  gap: 22px;\n}\n\n.flex-employment-card {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 20px;\n  border-radius: 18px;\n  background: #fff;\n  border: 1px solid rgba(187, 205, 226, 0.7);\n  box-shadow: 0 18px 35px rgba(28, 48, 81, 0.08);\n}\n\n.flex-employment-public-card {\n  position: relative;\n  overflow: hidden;\n  padding: 22px;\n  border-radius: 24px;\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(250, 252, 255, 0.98) 100%);\n  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;\n}\n\n.flex-employment-public-card:hover {\n  transform: translateY(-4px);\n  border-color: rgba(34, 107, 184, 0.34);\n  box-shadow: 0 24px 48px rgba(28, 48, 81, 0.14);\n}\n\n.flex-employment-public-card::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, rgba(253, 235, 208, 0.45) 0%, rgba(253, 235, 208, 0) 34%);\n  pointer-events: none;\n}\n\n.flex-employment-public-card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.flex-employment-public-rate {\n  color: #0f3f73;\n  font-size: 0.96rem;\n  font-weight: 800;\n}\n\n.flex-employment-card h3 {\n  margin: 0;\n  color: #10243d;\n  font-size: 1.45rem;\n  letter-spacing: -0.03em;\n}\n\n.flex-employment-card p {\n  margin: 0;\n  color: #42556d;\n  line-height: 1.5;\n}\n\n.flex-employment-meta {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 16px;\n}\n\n.flex-employment-meta > div {\n  padding: 12px 14px;\n  border-radius: 14px;\n  background: rgba(238, 244, 251, 0.85);\n}\n\n.flex-employment-meta strong {\n  display: block;\n  margin-bottom: 4px;\n  color: #10243d;\n}\n\n.flex-employment-skills {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.flex-employment-skill {\n  border-radius: 999px;\n  padding: 7px 11px;\n  background: #edf5ff;\n  color: #18437a;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.flex-employment-public-muted {\n  color: #6c7b8f;\n}\n\n.flex-employment-card-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: auto;\n}\n\n.flex-employment-search {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 16px;\n  align-items: end;\n  margin-bottom: 20px;\n  padding: 22px;\n  border-radius: 24px;\n  background: rgba(255, 255, 255, 0.82);\n  border: 1px solid rgba(187, 205, 226, 0.7);\n  box-shadow: 0 18px 34px rgba(20, 54, 92, 0.08);\n  backdrop-filter: blur(12px);\n}\n\n.flex-employment-search-field {\n  margin-bottom: 0;\n}\n\n.flex-employment-search-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.flex-employment-public-toolbar {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n  align-items: end;\n  margin-bottom: 18px;\n}\n\n.flex-employment-public-toolbar h2 {\n  margin: 8px 0 0;\n  color: #10243d;\n  font-size: clamp(1.5rem, 2vw, 2.1rem);\n  letter-spacing: -0.03em;\n}\n\n.flex-employment-public-toolbar p {\n  max-width: 420px;\n  margin: 0;\n  color: #55667d;\n  line-height: 1.6;\n}\n\n.flex-employment-form {\n  display: grid;\n  gap: 16px;\n  padding: 24px;\n  border-radius: 18px;\n  background: #fff;\n  border: 1px solid #dbe5f1;\n  box-shadow: 0 10px 24px rgba(20, 54, 92, 0.08);\n}\n\n.flex-employment-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.flex-employment-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.flex-employment-field.full-width {\n  grid-column: 1 / -1;\n}\n\n.flex-employment-field label {\n  font-weight: 700;\n  color: #10243d;\n}\n\n.flex-employment-field input,\n.flex-employment-field select,\n.flex-employment-field textarea {\n  width: 100%;\n  border: 1px solid #c8d6e5;\n  border-radius: 10px;\n  padding: 10px 12px;\n  font: inherit;\n  color: #10243d;\n  background: #fff;\n  box-sizing: border-box;\n}\n\n.flex-employment-field textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.flex-employment-field input:focus,\n.flex-employment-field select:focus,\n.flex-employment-field textarea:focus {\n  outline: none;\n  border-color: #1a73e8;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.16);\n}\n\n.flex-employment-section-title {\n  margin: 0 0 8px;\n  color: #10243d;\n}\n\n.flex-employment-empty {\n  padding: 32px;\n  border-radius: 18px;\n  background: #fff;\n  border: 1px dashed #c8d6e5;\n  text-align: center;\n  color: #42556d;\n}\n\n.flex-employment-candidate-list {\n  display: grid;\n  gap: 14px;\n}\n\n.flex-employment-candidate {\n  border: 1px solid #dbe5f1;\n  border-radius: 14px;\n  padding: 16px;\n}\n\n.flex-employment-candidate h4 {\n  margin: 0 0 8px;\n  color: #10243d;\n}\n\n.flex-employment-loading {\n  padding: 24px 0;\n  color: #42556d;\n}\n\n@media (max-width: 800px) {\n  .flex-employment-hero,\n  .flex-employment-form-grid,\n  .flex-employment-meta {\n    grid-template-columns: 1fr;\n    display: grid;\n  }\n\n  .flex-employment-page {\n    padding: 16px;\n  }\n\n  .flex-employment-public-toolbar,\n  .flex-employment-public-card-top,\n  .flex-employment-public-hero {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n\n  .flex-employment-search {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
